import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const userRegistrationAPI = createAsyncThunk('master-user/register', async (requestHeaders, { rejectWithValue }) => {
  try {
    const response = await fetch(
      `${ROOT_URL}/master-user/register`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestHeaders),
      },
    );
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const userRegistration = createSlice(
  {
    name: 'userRegistration',
    initialState,
    reducers: {},
    extraReducers: {
      [userRegistrationAPI.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [userRegistrationAPI.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        response: action.payload,
      }),
      [userRegistrationAPI.rejected]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      }),
    },
  },
);

export default userRegistration;
